import React, { useMemo, useRef } from "react";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import orderApi from "../services/orderApi";

const PayPalButton = ({
  customer,
  items,
  totalAmount,
  disabled,
  onSuccess,
  onError,
}) => {
  const orderIdRef = useRef(null);
  const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID || "";

  const initialOptions = useMemo(
    () => ({
      "client-id": clientId,
      currency: "USD",
      intent: "capture",
    }),
    [clientId]
  );

  const handleCreateOrder = async () => {
    try {
      if (disabled) {
        throw new Error("Please complete the checkout form first.");
      }

      const orderResponse = await orderApi.createOrder({
        customer,
        items,
        totalAmount,
      });

      orderIdRef.current = orderResponse.orderId;

      const paypalResponse = await orderApi.createPaypalOrder({
        orderId: orderResponse.orderId,
      });

      return paypalResponse.paypalOrderId;
    } catch (error) {
      onError?.(error);
      throw error;
    }
  };

  const handleApprove = async (data) => {
    try {
      const captureResponse = await orderApi.capturePaypalOrder({
        orderId: orderIdRef.current,
        paypalOrderId: data.orderID,
      });

      if (captureResponse.status === "paid") {
        onSuccess?.(captureResponse);
      } else {
        const err = new Error("Payment was not completed");
        onError?.(err);
        throw err;
      }
    } catch (error) {
      onError?.(error);
      throw error;
    }
  };

  if (!clientId) {
    return <p>PayPal client ID is not configured.</p>;
  }

  return (
    <PayPalScriptProvider options={initialOptions}>
      <PayPalButtons
        style={{ layout: "vertical", shape: "rect" }}
        createOrder={handleCreateOrder}
        onApprove={handleApprove}
        onError={onError}
        forceReRender={[totalAmount]}
      />
    </PayPalScriptProvider>
  );
};

export default PayPalButton;


